import { render } from "./ProcessOrdersList.vue?vue&type=template&id=b1a59244&scoped=true"
import script from "./ProcessOrdersList.vue?vue&type=script&lang=js"
export * from "./ProcessOrdersList.vue?vue&type=script&lang=js"

import "./ProcessOrdersList.vue?vue&type=style&index=0&id=b1a59244&lang=scss&scoped=true"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1a59244"]])

export default __exports__